import { get, post, put, del } from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const scoringRuleService = {
  /**
   * Create a new scoring rule
   */
  createScoringRule: async (ruleData) => {
    try {
      const response = await post(API_ENDPOINTS.CRM.SCORING_RULES, ruleData);

      if (response && response.responseCode === 201) {
        return {
          success: true,
          rule: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to create scoring rule'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to create scoring rule'
      };
    }
  },

  /**
   * Get all scoring rules
   */
  getAllScoringRules: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (filters.isActive !== undefined) queryParams.append('isActive', filters.isActive);
      if (filters.search !== undefined) queryParams.append('search', filters.search);

      const url = queryParams.toString()
        ? `${API_ENDPOINTS.CRM.SCORING_RULES}?${queryParams.toString()}`
        : API_ENDPOINTS.CRM.SCORING_RULES;

      const response = await get(url);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          rules: response.data || []
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to retrieve scoring rules',
          rules: []
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to retrieve scoring rules',
        rules: []
      };
    }
  },

  /**
   * Get scoring rule by ID
   */
  getScoringRuleById: async (ruleId) => {
    try {
      const response = await get(`${API_ENDPOINTS.CRM.SCORING_RULES}/${ruleId}`);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          rule: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to retrieve scoring rule'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to retrieve scoring rule'
      };
    }
  },

  /**
   * Update scoring rule
   */
  updateScoringRule: async (ruleId, ruleData) => {
    try {
      const response = await put(`${API_ENDPOINTS.CRM.SCORING_RULES}/${ruleId}`, ruleData);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          rule: response.data,
          message: response.responseMessage || 'Scoring rule updated successfully'
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to update scoring rule'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to update scoring rule'
      };
    }
  },

  /**
   * Delete scoring rule
   */
  deleteScoringRule: async (ruleId) => {
    try {
      const response = await del(`${API_ENDPOINTS.CRM.SCORING_RULES}/${ruleId}`);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          message: response.responseMessage || 'Scoring rule deleted successfully'
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to delete scoring rule'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to delete scoring rule'
      };
    }
  },

  /**
   * Export scoring rules
   */
  exportScoringRules: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams(filters);
      // API_ENDPOINTS.CRM.SCORING_RULES contains the full URL
      const url = `${API_ENDPOINTS.CRM.SCORING_RULES}/export?${queryParams.toString()}`;

      const token = localStorage.getItem('auth_token');
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const blob = await response.blob();
        return {
          success: true,
          data: blob
        };
      }

      return {
        success: false,
        error: 'Failed to export scoring rules'
      };

    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to export scoring rules'
      };
    }
  }
};

export default scoringRuleService;

